import { get,post } from "@/axios/http";
/** 点突变 */
const findMutationResult = data => post('/brave/report/findMutationResult',data);
/** 甲基化 */
const findMgmtResult = data => post('/brave/report/findMgmtResult',data);
/**染色体接口 */
const findFragmentResult = data => post('/brave/report/findFragmentResult',data);
export {
    findMutationResult,
    findMgmtResult,
    findFragmentResult
}